// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__3np42","tab":"style_tab__UOStG"};